import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'app/app.material';
import { RegistrationRouting } from './registration.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/**  Components  **/
import { RegistrationComponent } from './registration.component';
import { CreateAccountComponent } from 'app/theme/components/registration-pre/registration-pre.component';
import { CreateBennetAccountComponent } from 'app/theme/components/slide3/slide3.component';
import { InterestComponent } from 'app/theme/components/slide4/slide4.component';
import { VerificationComponent } from 'app/theme/components/slide2/slide2.component';
import { ClubComponent } from 'app/theme/components/slide5/slide5.component';
import { ModuleComponent } from 'app/theme/components/slide1/slide1.component';


import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

/**  Entries  **/
import { PDFComponent } from 'app/theme/shared/dialogs/pdf.component';

/**  Services  **/
import { UserService } from 'app/theme/services/user.service';
import { AlertService } from 'app/theme/services/alert.service';
import { ChannelService } from 'app/theme/services/channel.service';
import { LanguageService } from 'app/theme/services/language.service';
import { CodiceFiscaleService } from 'app/theme/services/codiceFiscale.service';
import { DataService } from 'app/theme/services/data.service';
import { AddressService } from 'app/theme/services/address.service';
import { CustomerService } from 'app/theme/services/customer.service';
import { EmailService } from 'app/theme/services/email.service';
import { CodeService } from 'app/theme/services/code.service';
import { CardService } from 'app/theme/services/card.service';
import { DialogService } from 'app/theme/services/dialog.service';
import { LoginComponent } from 'app/theme/shared/dialogs/login.component';
import { ANONIMOComponent } from 'app/theme/shared/dialogs/anonimo.component';

/**  Directives  **/

/**  Pipes  **/

@NgModule({
        imports: [
                CommonModule,
                AppMaterialModule,
                FormsModule,
                RegistrationRouting,
                ReactiveFormsModule,

                MatAutocompleteModule,
                MatInputModule,
                MatFormFieldModule,
        ],
        declarations: [
                RegistrationComponent,
                CreateAccountComponent,
                CreateBennetAccountComponent,
                InterestComponent,
                VerificationComponent,
                ClubComponent,
                ModuleComponent,
                PDFComponent,
                LoginComponent,
                ANONIMOComponent
        ],
        entryComponents: [
                PDFComponent, LoginComponent , ANONIMOComponent
        ],
        providers: [
                CardService,
                UserService,
                AlertService,
                ChannelService,
                LanguageService,
                CodiceFiscaleService,
                DialogService,
                DataService,
                AddressService,
                CustomerService,
                EmailService,
                CodeService
        ]
})
export class RegistrationModule { }



// WEBPACK FOOTER //
// ./src/app/pages/registration/registration.module.ts